import { Moment } from 'moment';
import { convertDateToIsoString, convertIso8601ToDate } from '@app/shared/date-helpers.service';

export class BlockQuote {
  id: number;
  shortLoadTypeId: number;
  freeShortLoadId: number;
  standbyChargeTypeId: number;
  salesmanEmployeeId: number;
  salesPlantId: number;
  blockRestockingCharge: number;
  blockRestockPercentFlag: boolean;
  priceAdjustment: number;
  termsDiscountId: number;
  nonworkdayChargeFlag: boolean;
  priceAdjustmentPercentFlag: boolean;
  object: string;

  private _startDate: Moment;
  get startDate(): Moment {
    return this._startDate;
  }
  set startDate(val) {
    this._startDate = convertIso8601ToDate(val);
  }

  private _terminationDate: Moment;
  get terminationDate(): Moment {
    return this._terminationDate;
  }
  set terminationDate(val) {
    this._terminationDate = convertIso8601ToDate(val);
  }

  constructor() {}

  toJSON(): Object {
    return convertDateToIsoString(this);
  }
}
